import styled from 'styled-components';
import tatryImage from '../../../../assets/images/mountains.webp';
import tatry2Image from '../../../../assets/images/tatry.webp';
import baticImage from '../../../../assets/images/malaga.webp';
import maderaImage from '../../../../assets/images/madera.webp';

import dyminImage from '../../../../assets/images/dymin.webp';
import szkocjaImage from '../../../../assets/images/szkocja_new.webp';
import defaultImage from '../../../../assets/images/default_image.webp';
import karkonoszeImage from '../../../../assets/images/default_image.webp';

const portugaliaPublic = '/images/portugalia.jpg';
const tatry2Public = '/images/tatry2.webp';
const karpatyPublic = '/images/karpaty.jpg';
const goryStolowePublic = '/images/g_stolowe.webp';

interface HikingContainerProps {
  background:
    | 'tatry'
    | 'malaga'
    | 'madera'
    | 'tatry2Old'
    | 'tatry2'
    | 'dymin'
    | 'szkocja'
    | 'karkonosze'
    | 'austria'
    | 'rumunia'
    | 'portugalia'
    | 'goryStolowe';
  isFeatured?: boolean;
}

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 70px 30px 10px 30px;
  position: relative;

  @media (max-width: 840px) {
    margin-top: 80px;
  }
`;

interface SectionTitleProps {
  large?: boolean;
}

export const SectionTitle = styled.h2<SectionTitleProps>`
  font-size: ${(props) => (props.large ? '2.2rem' : '1.4rem')};
  font-weight: ${(props) => (props.large ? 900 : 700)};
  color: #1a1a1a;
  text-align: center;
  margin: 30px 0 ${(props) => (props.large ? '20px' : '8px')} 0;
  letter-spacing: 0.08rem;
  line-height: 1.5;

  @media (max-width: 840px) {
    font-size: ${(props) => (props.large ? '1.8rem' : '1.2rem')};
    margin: 25px 0 6px 0;
  }
`;

export const SectionSubtitle = styled.p`
  font-size: 0.85rem;
  font-weight: 400;
  color: #666;
  text-align: center;
  margin: 0 auto 35px auto;
  max-width: 700px;
  line-height: 1.4;

  @media (max-width: 840px) {
    font-size: 0.8rem;
    margin: 0 auto 25px auto;
    padding: 0 20px;
  }
`;

interface SectionContainerProps {
  extraBottom?: boolean;
}

export const SectionContainer = styled.div<SectionContainerProps>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: 20px;
  width: 100%;
  margin-bottom: ${(props) => (props.extraBottom ? '40px' : '20px')};

  @media (max-width: 840px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const PictureContainer = styled.div<HikingContainerProps>`
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: ${(props) => (props.isFeatured ? '560px' : '250px')};
  height: ${(props) => (props.isFeatured ? '360px' : '167px')};
  flex-shrink: 0;
  background-image: ${(props) =>
    props.background === 'tatry'
      ? `url(${tatryImage})`
      : props.background === 'malaga'
        ? `url(${baticImage})`
        : props.background === 'tatry2Old'
          ? `url(${tatry2Image})`
          : props.background === 'tatry2'
            ? `url(${tatry2Public})`
            : props.background === 'dymin'
              ? `url(${dyminImage})`
              : props.background === 'szkocja'
                ? `url(${szkocjaImage})`
                : props.background === 'karkonosze'
                  ? `url(${karkonoszeImage})`
                  : props.background === 'madera'
                    ? `url(${maderaImage})`
                    : props.background === 'portugalia'
                      ? `url(${portugaliaPublic})`
                      : props.background === 'goryStolowe'
                        ? `url(${goryStolowePublic})`
                        : props.background === 'austria'
                          ? `url(${defaultImage})`
                          : props.background === 'rumunia'
                            ? `url(${karpatyPublic})`
                            : `url(${defaultImage})`};
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 840px) {
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    max-width: ${(props) => (props.isFeatured ? '100%' : '400px')};
    height: ${(props) => (props.isFeatured ? '280px' : '250px')};
  }
`;

interface ContentContainerProps {
  isPast?: boolean;
  isComming?: boolean;
  hasLabel?: boolean;
  isFeatured?: boolean;
}

interface ContentProps {
  isComming?: boolean;
  isFeatured?: boolean;
}

interface TitleProps {
  hasLabel?: boolean;
  isComming?: boolean;
  isFeatured?: boolean;
}

interface TextProps {
  isComming?: boolean;
}

interface ButtonProps {
  isComming?: boolean;
}

export const ContentContainer = styled.div<ContentContainerProps>`
  position: relative;
  opacity: ${(props) => (props.isPast ? 0.8 : 1)};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: ${(props) =>
    props.isFeatured ? 'auto' : props.isPast ? 'auto' : props.isComming ? '250px' : '360px'};
  min-height: ${(props) => (props.isPast ? '360px' : undefined)};
  width: ${(props) => (props.isFeatured ? '560px' : '250px')};
  background-color: ${(props) => (props.isPast ? '#F5F5F5' : '#F8F6F2')};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 840px) {
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: auto;
    min-height: ${(props) => (props.isFeatured ? 'auto' : '400px')};
    width: 100%;
    max-width: ${(props) => (props.isFeatured ? '100%' : '400px')};
  }
`;

export const Content = styled.div<ContentProps>`
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => (props.isComming ? 'space-around' : 'space-between')};
  align-items: center;
  text-align: center;
  padding: ${(props) => (props.isFeatured ? '20px 24px' : props.isComming ? '6px 6px' : '8px 8px')};
  flex: ${(props) => (props.isFeatured ? 'none' : '1 1 auto')};
  min-height: 0;
  width: 100%;
  box-sizing: border-box;
`;

export const UpcommingTreksContent = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  height: 100%;
  border-bottom: 1px solid black;
`;

export const Text = styled.p<TextProps>`
  color: #333;
  font-weight: 600;
  font-size: 0.8em;
  line-height: 1.5em;
  letter-spacing: 0.01rem;
  text-align: center;
  width: 100%;
  margin: ${(props) => (props.isComming ? '0.5px 0' : '1px 0')};

  @media (max-width: 840px) {
    width: 100%;
    padding: 0 15px;
  }
`;

export const SmallColoredText = styled.p`
  display: flex;
  color: white;
  font-weight: 700;
  font-size: 0.4em;
  letter-spacing: 0.02rem;
  text-align: center;
  margin: 0;

  @media (max-width: 840px) {
    width: 100%;
    padding: 0 15px;
  }
`;

export const SmallColoredContainer = styled.div`
  position: absolute;
  top: 6px;
  right: 6px;
  width: 85px;
  height: 18px;
  background-color: #4caf50;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 10;
`;

export const Title = styled.h1<TitleProps>`
  color: #1a1a1a;
  font-weight: 800;
  font-size: ${(props) => (props.isFeatured ? '1.6em' : '1em')};
  line-height: 1.35em;
  letter-spacing: 0.05rem;
  margin: 0 0 ${(props) => (props.isComming ? '3px' : '5px')} 0;
  text-align: center;
  padding-top: ${(props) => (props.isFeatured ? '8px' : props.isComming ? '15px' : '22px')};
  min-height: ${(props) => (props.isFeatured ? 'auto' : props.isComming ? '30px' : '40px')};
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1200px) {
    font-size: 1em;
  }
  @media (max-width: 840px) {
    font-size: 2.5em;
    padding-top: 0;
    min-height: auto;
  }
`;

export const Subtitle = styled.h2`
  margin-bottom: 30px;
  font-weight: 700;
  line-height: 1.5em;
  letter-spacing: 0.1rem;
  font-size: 1.6em;
  margin: 0 15px;
`;

export const ButtonStyled = styled.button<ButtonProps>`
  width: 100%;
  margin-top: ${(props) => (props.isComming ? '4px' : '6px')};
  font-weight: 700;
  font-size: 0.8em;
  padding: ${(props) => (props.isComming ? '12px 14px' : '14px 16px')};
  background-color: #1a1a1a;
  color: white;
  border: none;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    background-color: #af9483;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  &:focus {
    background-color: #af9483;
    outline: none;
  }

  &:disabled {
    background-color: #dad1c7;
    color: #faf6f1;
    box-shadow: none;
    cursor: not-allowed;
    transform: none;
  }
`;

export const SectionDivider = styled.div`
  width: 100%;
  height: 2px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    #ccc 20%,
    #999 50%,
    #ccc 80%,
    transparent 100%
  );
  margin: 30px 0;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: -1px;
    left: 50%;
    transform: translateX(-50%);
    width: 8px;
    height: 4px;
    background-color: #999;
    border-radius: 2px;
  }

  @media (max-width: 840px) {
    margin: 20px 0;
  }
`;

// KARKONOSZE: Responsive containers specific for info section
export const InfoSection = styled.section`
  width: 100%;
  max-width: 1000px;
  margin: 0 auto 24px auto;
  padding: 0 16px;
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 840px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const InfoCard = styled.div`
  position: relative;
  background-color: transparent;
  border-radius: 0;
  padding: 0;
  box-shadow: none;
`;

// Dedicated styles for Karkonosze section
export const KarkonoszeSection = styled.section`
  width: 100%;
  max-width: 1000px;
  margin: 0 auto 24px auto;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const KarkonoszeGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 840px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const KarkonoszeBlock = styled.div`
  width: 100%;
  max-width: 820px;
  margin: 0 auto 12px auto;
  text-align: center;
`;

export const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 10px;

  a img {
    height: 28px;
    width: auto;
    filter: brightness(0) saturate(100%);
  }

  a:hover img {
    opacity: 0.8;
  }
`;
